/**
 * Moves programmatic focus to an in-page skip-link target while leaving the
 * browser's native hash navigation and scrolling intact.
 */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest('a[data-skip-to-content]');
  if (!(link instanceof HTMLAnchorElement)) return;

  const url = new URL(link.href, window.location.href);
  if (
    url.origin !== window.location.origin ||
    url.pathname !== window.location.pathname ||
    url.search !== window.location.search ||
    !url.hash
  ) {
    return;
  }

  const target = document.querySelector(url.hash);
  if (!(target instanceof HTMLElement)) return;

  requestAnimationFrame(() => target.focus({ preventScroll: true }));
});
